import "../../../assets/css/style.css";
import { Link } from "react-router";
import { useEffect, useState } from "react";
import { ProjectsDataType, SiteData } from "../../../interface/site.interface";
import { PortfolioService } from "../../../services/portfolio.service";
import { useLanguage } from "../../../context/LanguageContext";
import { useSite } from "../../../context/SiteContext";

const Index = () => {
  const { language } = useLanguage();
  const { data } = useSite() as { data: SiteData };
  const [projects, setProjects] = useState<ProjectsDataType[]>([]);
  const [lasted, setLasted] = useState<ProjectsDataType[]>([]);
  useEffect(() => {
    PortfolioService.getAllPortfolio().then((res) => {
      setProjects(res.data.data);
    });
    PortfolioService.getLastedPortfolio().then((res) => {
      setLasted(res.data.data);
    });
  }, [language]);
  return (
    <section>
      <div className="myProject-hero-title">{data?.portfolio}</div>
      <div className="myProject-hero-all">
        {projects.map((item, index) => {
          return (
            <Link
              key={item.id}
              to={
                item.portfolio_type === "mobile"
                  ? `/mobileprojects/${item.id}`
                  : `/vebproject/${item.id}`
              }
              className="myProject-hero-all-right"
            >
              <div
                className="myProject-hero-all-right-image"
                style={{
                  backgroundColor: index === 0 ? "#a8c5ff" : "#92ee8c80",
                }}
              >
                <img src={item.image} alt={item.title || ""} />
              </div>
              <div className="myProject-content">
                <h3>{item.title || <span>&nbsp;</span>}</h3>
                <p
                  dangerouslySetInnerHTML={{
                    __html: item.description || "<span>&nbsp;</span>",
                  }}
                ></p>
              </div>
            </Link>
          );
        })}
      </div>
      <div className="myProject-hero-title">{data?.latest_projects}</div>
      <div className="myProject-hero-all second-all">
        {/* <Link to="/vebproject" className="myProject-hero-all-right">
          <div className="myProject-hero-all-right-image  second-right">
            <img src={card2} alt="" />
          </div>
          <div className="myProject-content">
            <h3>Veb Sayt</h3>
            <p>Flyex Kargo</p>
          </div>
        </Link>
        <Link to="/mobileprojects" className="myProject-hero-all-right">
          <div className="myProject-hero-all-right-image second-left">
            <img src={card2} alt="" />
          </div>
          <div className="myProject-content">
            <h3>Mobil Tetbiq Sayt</h3>
            <p>Dostex Kargo</p>
          </div>
        </Link> */}
        {lasted?.map((item, index) => {
          console.log(item.image);
          return (
            <Link
              key={item.id}
              to={
                item.portfolio_type === "mobile"
                  ? `/mobileprojects/${item.id}`
                  : `/vebproject/${item.id}`
              }
              className="myProject-hero-all-right"
            >
              <div
                className="myProject-hero-all-right-image second-left"
                style={{
                  backgroundColor: index === 0 ? "#92ee8c80" : "#a8c5ff",
                }}
              >
                <img src={item.image} alt="" />
              </div>
              <div className="myProject-content">
                <h3>{item.title}</h3>
                <p>{item.description}</p>
              </div>
            </Link>
          );
        })}
      </div>
    </section>
  );
};

export default Index;
